import { type ForwardedRef, forwardRef } from 'react';
import { EmployeeIdpType } from '@/common/graphql';
import { EmployeeIdpTypeLabels } from '@/common/types';
import { ObjectUtils } from '@/common/utils';
import type { ComboboxItemWithFormatted } from '../props';
import { SelectMultiple, type SelectMultipleProps } from '../SelectMultiple';
import { SelectSingle, type SelectSingleProps } from '../SelectSingle';

interface EmployeeIdpTypeSelectSingleProps
  extends Omit<SelectSingleProps<ComboboxItemWithFormatted<EmployeeIdpType>>, 'searchable' | 'value'> {
  value: EmployeeIdpType | null;
}

interface EmployeeIdpTypeSelectMultipleProps
  extends Omit<SelectMultipleProps<ComboboxItemWithFormatted<EmployeeIdpType>>, 'searchable' | 'value'> {
  value: Array<EmployeeIdpType> | null | undefined;
}

const data = ObjectUtils.arrayFromEnumValues<EmployeeIdpType>(EmployeeIdpType).map(
  value =>
    ({
      value,
      label: EmployeeIdpTypeLabels[value],
    }) as ComboboxItemWithFormatted<EmployeeIdpType>,
);

export const EmployeeIdpTypeSelectSingle = forwardRef(
  (
    { placeholder = 'Select IDP type', ...rest }: EmployeeIdpTypeSelectSingleProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => <SelectSingle ref={ref} {...rest} data={data} loading={false} placeholder={placeholder} searchable={false} />,
);

export const EmployeeIdpTypeSelectMultiple = ({ ...rest }: EmployeeIdpTypeSelectMultipleProps) => (
  <SelectMultiple
    {...rest}
    data={data}
    loading={false}
    multipleSelectedLabel={length => `${length} types`}
    placeholder={rest.placeholder}
    searchable={false}
  />
);
